module.exports = __webpack_public_path__ + "img/whitelist.png?81a04e051589e8f7a8fc9e72ca44e259";